import React from "react";
import { Flex } from "@chakra-ui/react";
import { BookDemoButton } from "components/event-tracking";
import { HeroSpotlightBackgroundEffects } from "components/hero";
import { Section } from "components/section";
import { FadeIn } from "ui/animations";
import { TextTitle } from "ui/text";
import { HeroAnimation } from "./animations";

type CampaignIntelligenceHeroProps = {
  eyebrow: string;
  title: string;
  description: string;
};

export function CampaignIntelligenceHero({ eyebrow, title, description }: CampaignIntelligenceHeroProps) {
  return (
    <Section
      theme="dark"
      bg="new.violet.950"
      themeBgColor="new.violet.950"
      pos="relative"
      py="0"
      pt={{ base: "biggest", lg: "huge" }}
      pb={{ base: "huge", lg: "huger" }}
      overflow="hidden"
    >
      <HeroSpotlightBackgroundEffects theme="dark" bgColor="new.violet.950" spotlightColor="new.violet.900" />
      <FadeIn duration={0.3}>
        <Flex
          gap={{ base: "biggest", lg: "big" }}
          flexDir={{ base: "column", lg: "row" }}
          alignItems="center"
          pos="relative"
        >
          <TextTitle
            theme="dark"
            size="xl"
            chip={{ text: eyebrow }}
            titleAs="h1"
            title={title}
            descriptionAs="h2"
            description={description}
            actions={<BookDemoButton />}
          />
          <HeroAnimation />
        </Flex>
      </FadeIn>
    </Section>
  );
}
